import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/AuthContext';
import { BusinessProvider } from './components/BusinessContext';
import { MobileHeader } from './components/MobileHeader';
import { WelcomeScreen } from './components/WelcomeScreen';
import { Discover } from './pages/Discover';
import { Shop } from './pages/Shop';
import { Help } from './pages/Help';
import { ListingDetail } from './pages/ListingDetail';
import { Requests } from './pages/Requests';
import { Messages } from './pages/Messages';
import { Saved } from './pages/Saved';
import { MyAI } from './pages/MyAI';
import { Profile } from './pages/Profile';
import { SellFlow } from './pages/SellFlow';
import { BusinessHub } from './pages/BusinessHub';
import { BusinessHubWelcomeModal } from './components/BusinessHubWelcomeModal';
// First-launch welcome screen — shown until the user signs in or chooses to
// continue as a guest. Lives inside the phone frame.
function WelcomeGate() {
  const {
    hasEntered
  } = useAuth();
  return <AnimatePresence data-id="element-0">{!hasEntered && <WelcomeScreen data-id="element-1" />}</AnimatePresence>;
}
export function App() {
  // Everyone can browse + chat freely. Registration is only required for
  // gated actions (e.g. viewing full listing details) via AuthProvider.
  // Business Hub activates adaptively via BusinessProvider.
  return <AuthProvider data-id="element-2">
      <BusinessProvider data-id="element-3">
        <BrowserRouter data-id="element-4">
          <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4 sm:p-8 font-body" data-id="element-5">
            {/* Device Frame */}
            <div className="w-full max-w-[393px] h-[852px] bg-white rounded-[3rem] shadow-2xl overflow-hidden relative border-[8px] border-slate-900 flex flex-col ring-1 ring-slate-900/10" data-id="element-6">
              {/* Dynamic Island / Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[120px] h-[30px] bg-slate-900 rounded-b-3xl z-[60]" data-id="element-7"></div>

              {/* App Content */}
              <div id="app-screen-root" className="flex-1 flex flex-col relative w-full h-full overflow-hidden bg-white" data-id="element-8">
                <MobileHeader data-id="element-9" />

                <main className="flex-1 flex flex-col relative overflow-y-auto overflow-x-hidden bg-white [&>*]:flex-1 [&>*]:min-h-0" data-id="element-10">
                  <Routes data-id="element-11">
                    <Route path="/" element={<Discover data-id="element-13" />} data-id="element-12" />
                    <Route path="/shop/:slug" element={<Shop data-id="element-15" />} data-id="element-14" />
                    <Route path="/listing/:id" element={<ListingDetail data-id="element-17" />} data-id="element-16" />
                    <Route path="/requests" element={<Requests data-id="element-19" />} data-id="element-18" />
                    <Route path="/saved" element={<Saved data-id="element-21" />} data-id="element-20" />
                    <Route path="/messages" element={<Messages data-id="element-23" />} data-id="element-22" />
                    <Route path="/my-ai" element={<MyAI data-id="element-25" />} data-id="element-24" />
                    <Route path="/business" element={<BusinessHub data-id="element-27" />} data-id="element-26" />
                    <Route path="/profile" element={<Profile data-id="element-29" />} data-id="element-28" />
                    <Route path="/sell" element={<SellFlow data-id="element-31" />} data-id="element-30" />
                    <Route path="/help" element={<Help data-id="element-33" />} data-id="element-32" />
                  </Routes>
                </main>

                <WelcomeGate data-id="element-34" />
              </div>
            </div>
          </div>

          <BusinessHubWelcomeModal data-id="element-35" />
        </BrowserRouter>
      </BusinessProvider>
    </AuthProvider>;
}